import { Spinner } from '@nextui-org/react'
import React from 'react'

export default function SpinnerPage(props) {
  const { text , color="primary"} = props
  return (
    <div className="w-full h-full text-center p-10">
      <Spinner label={text} color={color}/>
    </div>
  )
}
